import { StoredLocationProvider } from '../providers/storedLocationProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_LOCATION_LIST = new AsyncAction('GET_LOCATION_LIST');

export function getStoredLocationList(baseUrl, authId, secret, stdParameters, verbose, refresh = false) {
    return {
        type: GET_LOCATION_LIST.base,
        payload: getStoredLocationListAction(baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getStoredLocationListAction(baseUrl, authId, secret, stdParameters, verbose, refresh = false, locationId, notificationOptionsType) {

    const op = new StoredLocationProvider(baseUrl, authId, secret);
    return await op.getStoredLocationList(stdParameters, verbose, refresh, locationId, notificationOptionsType);
}


export const UPDATE_LOCATION = new AsyncAction('UPDATE_LOCATION');

export function updateStoredLocation(baseUrl, authId, secret, stdParameters, verbose, locationId, isNotificationEnabled, notificationOptionsType) {
    return {
        type: UPDATE_LOCATION.base,
        payload: updateStoredLocationAction(baseUrl, authId, secret, stdParameters, verbose, locationId, isNotificationEnabled, notificationOptionsType)
    };
}

async function updateStoredLocationAction(baseUrl, authId, secret, stdParameters, verbose, locationId, isNotificationEnabled, notificationOptionsType) {

    const op = new StoredLocationProvider(baseUrl, authId, secret);
    return await op.updateStoredLocation(stdParameters, verbose, locationId, isNotificationEnabled, notificationOptionsType);
}